import React from "react";

interface PropsLine {
    linesHorizontal: any[];
}

export default function LinesHorizontal({linesHorizontal}: PropsLine) {
    const renderLine = (line: any, index: number) => {
        let person1X, person1Y, person2X, person2Y;

        person1X = (line.person2.x > line.person1.x ? (line.person1.x + line.person1.width) : (line.person1.x));
        person1Y = (line.person1.y + (line.person1.height / 2));
        person2X = (line.person2.x > line.person1.x ? line.person2.x : line.person2.x + (line.person2.width));
        person2Y = (line.person2.y + (line.person2.height / 2));

        // Calcular puntos de control para la curva de Bézier
        const controlPointX1 = person1X + (person2X - person1X) / 2;
        const controlPointY1 = person1Y;
        const controlPointX2 = person2X - (person2X - person1X) / 2;
        const controlPointY2 = person2Y;

        return (
            <g key={index}>
                <path
                    d={`M${person1X},${person1Y} C${controlPointX1},${controlPointY1} ${controlPointX2},${controlPointY2} ${person2X},${person2Y}`}
                    fill="none"
                    stroke={line?.color ? line.color : '#FF9900'}
                    strokeWidth="1"
                />
                <circle
                    cx={person1X}
                    cy={person1Y}
                    r={3} // Tamaño del círculo
                    style={{
                        fill: line?.color ? line.color : '#FF9900',
                    }}
                />
                <circle
                    cx={person2X}
                    cy={person2Y}
                    r={3} // Tamaño del círculo
                    style={{
                        fill: line?.color ? line.color : '#FF9900',
                    }}
                />
            </g>
        );
    }

    return (
        <>
            {linesHorizontal && linesHorizontal.length > 0 && linesHorizontal.map((line, index) => {
                if (line.entry || line?.deactivateHover) {
                    return <svg key={index}
                                style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', pointerEvents: 'none', zIndex: 0}}>
                        {renderLine(line, index)}
                    </svg>
                }
            })}
        </>
    )
}
